import type { DownloadLink } from '../models';

/** rag_source and report_file links split into their two display groups. */
export interface DownloadLinkGroups {
  sourceLinks: DownloadLink[];
  downloadLinks: DownloadLink[];
}

/** Classify links into 情報源 (rag_source) and ダウンロード (report_file) groups. */
export function splitDownloadLinks(links?: readonly DownloadLink[]): DownloadLinkGroups {
  const sourceLinks: DownloadLink[] = [];
  const downloadLinks: DownloadLink[] = [];
  for (const link of links ?? []) {
    if (link.type === 'rag_source') sourceLinks.push(link);
    else if (link.type === 'report_file') downloadLinks.push(link);
  }
  return { sourceLinks, downloadLinks };
}

/** Whether either group contains at least one link. */
export function hasDownloadLinks(groups: DownloadLinkGroups): boolean {
  return groups.sourceLinks.length > 0 || groups.downloadLinks.length > 0;
}

/** Total number of links across both groups. */
export function countDownloadLinks(groups: DownloadLinkGroups): number {
  return groups.sourceLinks.length + groups.downloadLinks.length;
}

/** Human-readable name for a link — label when present, otherwise file name. */
export function getDownloadLinkDisplayName(link: DownloadLink): string {
  return link.label || link.fileName;
}

/** Stable React key that tolerates duplicate links. */
export function getDownloadLinkKey(link: DownloadLink, index: number): string {
  return `${link.type}:${link.fileName}:${link.url}:${index}`;
}
